import { isShadowRoot } from "./auth-service-tools1025.js";

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();

  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }

      next = next.parentNode || next.host;
    } while (next);
  }

  return false;
}

export { contains as default };